import {
  jb_mail_icon_css_default
} from "./chunk.5BI7LJBA.js";
import {
  jb_internal_icon_css_default
} from "./chunk.TYFJBEM6.js";
import {
  jb_in_page_icon_css_default
} from "./chunk.AKV4HQO3.js";
import {
  jb_download_icon_css_default
} from "./chunk.LB6T4MUO.js";
import {
  jb_external_icon_css_default
} from "./chunk.PJHBZAEK.js";
import {
  iconNames
} from "./chunk.FAIFMIM2.js";
import {
  to
} from "./chunk.BMHRULEY.js";
import {
  jb_content_spacing_css_default
} from "./chunk.CIGNFZYQ.js";
import {
  Rt
} from "./chunk.DS2KVX5X.js";
import {
  reset_css_default
} from "./chunk.PBU2AIHD.js";
import {
  customElement
} from "./chunk.QAGUCU4C.js";
import {
  Icon
} from "./chunk.IIVCI7D3.js";
import {
  Initiable
} from "./chunk.6DHNIVN5.js";
import {
  JBCookie,
  querySelectorAllShadow,
  smoothScroll
} from "./chunk.NKAUZW5M.js";
import {
  ke,
  r
} from "./chunk.NBIYIO67.js";
import {
  n,
  o,
  r as r2,
  r2 as r3
} from "./chunk.QXWAL3TN.js";
import {
  __decorateClass
} from "./chunk.2QRLEY22.js";

// src/components/icons/jb-external-icon/jb-external-icon.ts
var JbExternalIcon = class extends Icon(r) {
  render() {
    return ke`
      <svg
        viewBox="0 0 18 18"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M14.0601 9.07511C13.6988 9.07511 13.4059 9.36799 13.4059 9.72932V14.6917C13.4059 15.243 12.9573 15.6916 12.4059 15.6916H3.30832C2.75698 15.6916 2.30841 15.243 2.30841 14.6917V5.59404C2.30841 5.0427 2.75698 4.59413 3.30832 4.59413H8.27066C8.63196 4.59413 8.92487 4.30122 8.92487 3.93992C8.92487 3.57862 8.63196 3.28571 8.27066 3.28571H3.30832C2.03553 3.28571 1 4.32124 1 5.59404V14.6917C1 15.9645 2.03553 17 3.30832 17H12.4059C13.6787 17 14.7143 15.9645 14.7143 14.6917V9.72932C14.7143 9.36799 14.4214 9.07511 14.0601 9.07511Z"
        />
        <path
          d="M16.4039 1H11.8819C11.5526 1 11.2857 1.26692 11.2857 1.59615C11.2857 1.92539 11.5526 2.1923 11.8819 2.1923H15.8077V6.11813C15.8077 6.44737 16.0746 6.71429 16.4039 6.71429C16.7331 6.71429 17 6.44737 17 6.11813V1.59615C17 1.26692 16.7331 1 16.4039 1Z"
        />
        <path
          d="M16.8106 1.18938C16.5581 0.936874 16.1486 0.936874 15.8961 1.18938L6.90368 10.1818C6.65115 10.4343 6.65115 10.8438 6.90368 11.0963C7.02993 11.2226 7.19545 11.2857 7.36094 11.2857C7.52647 11.2857 7.69196 11.2226 7.81821 11.0963L16.8106 2.10388C17.0631 1.85134 17.0631 1.44191 16.8106 1.18938Z"
        />
      </svg>
    `;
  }
};
JbExternalIcon.styles = [reset_css_default, jb_external_icon_css_default];
JbExternalIcon = __decorateClass([
  customElement("jb-external-icon")
], JbExternalIcon);

// src/components/icons/jb-in-page-icon/jb-in-page-icon.ts
var JbInPageIcon = class extends Icon(r) {
  render() {
    return ke`
      <svg
        fill="currentColor"
        viewBox="0 0 18 18"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M9.44466 16.8122C9.16767 17.0892 8.71861 17.0892 8.44165 16.8122L3.7878 12.1584C3.51084 11.8814 3.51081 11.4323 3.7878 11.1553C4.06479 10.8784 4.51385 10.8784 4.79081 11.1553L8.94315 15.3077L13.0955 11.1553C13.3725 10.8784 13.8215 10.8784 14.0985 11.1553C14.3755 11.4323 14.3755 11.8814 14.0985 12.1584L9.44466 16.8122Z"
        />
        <rect
          x="9.7"
          y="1"
          width="15"
          height="1.5"
          transform="rotate(90 9.7 1)"
        />
      </svg>
    `;
  }
};
JbInPageIcon.styles = [reset_css_default, jb_in_page_icon_css_default];
JbInPageIcon = __decorateClass([
  customElement("jb-in-page-icon")
], JbInPageIcon);

// src/components/icons/jb-internal-icon/jb-internal-icon.ts
var JbInternalIcon = class extends Icon(r) {
  render() {
    return ke`
      <svg
        viewBox="0 0 18 18"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clip-path="url(#clip0_0_1765)">
          <path
            d="M16.8122 8.55535C17.0892 8.83234 17.0892 9.2814 16.8122 9.55836L12.1584 14.2122C11.8814 14.4892 11.4323 14.4892 11.1554 14.2122C10.8784 13.9352 10.8784 13.4862 11.1554 13.2092L15.3077 9.05686L11.1554 4.90452C10.8784 4.62753 10.8784 4.17847 11.1554 3.90151C11.4323 3.62454 11.8814 3.62452 12.1584 3.90151L16.8122 8.55535Z"
          />
          <rect
            x="1"
            y="8.3"
            width="15"
            height="1.5"
          />
        </g>
        <clipPath id="clip0_0_1765">
          <rect
            width="16"
            height="12"
            fill="white"
            transform="translate(1 3)"
          />
        </clipPath>
      </svg>
    `;
  }
};
JbInternalIcon.styles = [reset_css_default, jb_internal_icon_css_default];
JbInternalIcon = __decorateClass([
  customElement("jb-internal-icon")
], JbInternalIcon);

// src/components/icons/jb-mail-icon/jb-mail-icon.ts
var JbMailIcon = class extends Icon(r) {
  render() {
    return ke`<svg
      fill="currentColor"
      viewBox="0 0 18 18"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15 3C16.1046 3 17 3.89543 17 5V13C17 14.1046 16.1046 15 15 15H3C1.89543 15 1 14.1046 1 13V5C1 3.89543 1.89543 3 3 3H15ZM2.299 5.007L2.3 13C2.3 13.3544 2.56334 13.6473 2.90501 13.6936L3 13.7H15C15.3544 13.7 15.6473 13.4367 15.6936 13.095L15.7 13V5.034L9.37049 9.52994C9.17265 9.67045 8.91587 9.68759 8.70369 9.58155L8.61579 9.52856L2.299 5.007ZM14.489 4.299H3.544L8.995 8.201L14.489 4.299Z"
      />
    </svg>`;
  }
};
JbMailIcon.styles = [reset_css_default, jb_mail_icon_css_default];
JbMailIcon = __decorateClass([
  customElement("jb-mail-icon")
], JbMailIcon);

// src/mixins/Linkable.ts
var LinkableEvents = class {
  constructor() {
    this["jb-link:clicked"] = void 0;
    this["jb-link:initialized"] = void 0;
  }
};
function registerLinkClickHandlers(linkTag, linkableComponent = void 0) {
  linkTag.addEventListener("click", (clickEvent) => {
    const textContent = linkableComponent?.getTextContent?.() ?? linkTag.innerText;
    const detail = { linkTag, clickEvent, linkableComponent, textContent, noGenericLinkTracking: false };
    if (linkTag.dataset.jblinkdata !== void 0) {
      const jblinkdata = JSON.parse(linkTag.dataset.jblinkdata);
      Object.assign(detail, jblinkdata);
    }
    if (linkableComponent?.link?.href && linkableComponent?.link?.href !== "#") {
      const linkFragment = linkableComponent.link.href.split("#")[1];
      if (typeof linkFragment !== "undefined") {
        const targets = querySelectorAllShadow(`#${linkFragment}`);
        if (targets.length === 1) {
          smoothScroll(targets[0]);
        }
      }
    }
    const customEvent = new CustomEvent("jb-link:clicked", {
      detail: {
        ...detail,
        trigger: "Linkable"
      },
      bubbles: true,
      composed: true
    });
    clickEvent.target?.dispatchEvent(customEvent);
  });
}
function jbLinkClickedEventToJbTrackingEvent(jbLinkClickedEvent, preconfiguredDetails) {
  const { type, linkTag } = jbLinkClickedEvent.detail;
  let trackingType;
  if (jbLinkClickedEvent.detail.contactIframeUrl || jbLinkClickedEvent.detail.contactOverlayForm) {
    trackingType = "contactOverlay";
  } else if (jbLinkClickedEvent.detail.publicationOverlay) {
    trackingType = "publicationDownloadOverlay";
  } else if (jbLinkClickedEvent.detail.cookieSettings) {
    trackingType = "cookieSettings";
  } else {
    trackingType = type || "internal";
  }
  let detail;
  switch (trackingType) {
    case "contactOverlay":
      detail = {
        event: "ce_interaction",
        interaction_effect: "open",
        interaction_element: "Overlay Links",
        interaction_result: `Contact | ${jbLinkClickedEvent.detail.contactFormUid}`,
        interaction_type: "click"
      };
      break;
    case "download":
      detail = {
        event: "ce_download",
        file_name: jbLinkClickedEvent.detail.downloadFileName.split(".").shift(),
        file_type: jbLinkClickedEvent.detail.downloadFileName.split(".").pop().toLocaleLowerCase()
      };
      break;
    case "external":
    case "internal":
      detail = {
        event: "ce_interaction",
        interaction_effect: "navigation",
        interaction_element: type === "internal" ? "Internal Links" : "External Links",
        interaction_result: new URL(linkTag.href).href,
        interaction_type: "click"
      };
      break;
    case "social":
      detail = {
        event: "ce_interaction",
        interaction_effect: "navigation",
        interaction_element: "Social Links",
        interaction_result: new URL(linkTag.href).href,
        interaction_type: "click"
      };
      break;
    case "publicationDownloadOverlay":
      detail = {
        event: "ce_interaction",
        interaction_effect: "open",
        interaction_element: "Overlay Links",
        interaction_result: `Download | ${jbLinkClickedEvent.detail.publicationOverlay.title}`,
        interaction_type: "click"
      };
      break;
    default:
      return;
  }
  jbLinkClickedEvent.stopPropagation();
  document.body.dispatchEvent(
    new CustomEvent("jb-link:clicked", {
      detail: {
        ...jbLinkClickedEvent.detail,
        noGenericLinkTracking: true
      },
      bubbles: true,
      composed: true
    })
  );
  return new CustomEvent("jb-tracking", {
    detail: { ...detail, ...preconfiguredDetails, event_version: "v2" },
    bubbles: true,
    composed: true
  });
}
function initializeLink(linkTag, linkableComponent = void 0) {
  if (!linkTag) {
    return;
  }
  if (!linkTag.dataset.linkInitialized) {
    registerLinkClickHandlers(linkTag, linkableComponent);
  }
  linkTag.dataset.linkInitialized = "true";
  const customEvent = new CustomEvent("jb-link:initialized", {
    bubbles: true,
    composed: true,
    detail: { ...JSON.parse(linkTag.dataset.jblinkdata || "{}"), linkTag, linkableComponent }
  });
  linkTag.dispatchEvent(customEvent);
}
function getMarketSpecificHref(marketUris) {
  if (marketUris === void 0) {
    return void 0;
  }
  const userMarket = parseInt(JBCookie.getI18nCookieData().market, 10);
  if (userMarket === 0) {
    return void 0;
  }
  const matchingEntry = marketUris.find((entry) => entry.marketUid === userMarket);
  if (!matchingEntry) {
    return void 0;
  }
  return matchingEntry.href;
}
function getLinkDefaultValues() {
  return {};
}
function setLinkAttributes(element, link) {
  if (!element || !link) {
    return;
  }
  const defaultValues = getLinkDefaultValues();
  const {
    data = defaultValues.data,
    download = defaultValues.download,
    href = defaultValues.href,
    name = defaultValues.name,
    target = defaultValues.target
  } = link;
  const marketSpecificHref = getMarketSpecificHref(link.marketUris);
  element.setAttribute("href", marketSpecificHref || href || "#");
  if (name) {
    element.setAttribute("name", name);
  } else {
    element.removeAttribute("name");
  }
  if (download) {
    element.setAttribute("download", "");
  } else {
    element.removeAttribute("download");
  }
  if (target) {
    element.setAttribute("target", target);
  } else {
    element.removeAttribute("target");
  }
  if (data) {
    element.setAttribute("data-jblinkdata", JSON.stringify(data));
  } else {
    element.removeAttribute("data-jblinkdata");
  }
}
function setLink(element, link) {
  setLinkAttributes(element, link);
  initializeLink(element);
}
function getLinkIcon(type) {
  if (type === "mail") {
    return ke`<jb-mail-icon></jb-mail-icon>`;
  }
  if (type === "download") {
    return ke`<jb-download-icon></jb-download-icon>`;
  }
  if (type === "in-page") {
    return ke`<jb-in-page-icon></jb-in-page-icon>`;
  }
  if (type === "internal") {
    return ke`<jb-internal-icon></jb-internal-icon>`;
  }
  if (type === "external") {
    return ke`<jb-external-icon></jb-external-icon>`;
  }
  return "";
}
function getLinkIconName(type) {
  if (type === "mail") return "MAIL";
  if (type === "download") return "DOWNLOAD";
  if (type === "in-page") return "IN_PAGE";
  if (type === "internal") return "INTERNAL";
  if (type === "external") return "EXTERNAL";
  if (iconNames.includes(type)) return type;
  return void 0;
}
function Linkable(baseClass) {
  class LinkableMixin extends baseClass {
    update(changedProperties) {
      super.update(changedProperties);
      if (changedProperties.has("link")) {
        this._linkTags?.forEach((linkTag) => {
          setLinkAttributes(linkTag, this.link);
          initializeLink(linkTag, this);
        });
      }
    }
    getTextContent() {
      return null;
    }
    /**
     * Override this method in your web component if you want to define default link values.
     * { target: '_blank' } will make your link open in a new window, if the link data don't explicitly set a different target
     * { download: true } will set a download attribute on your link, if the link data don't explicitly set it to false
     */
    _getLinkDefaultValues() {
      return {};
    }
  }
  __decorateClass([
    n({ type: Object })
  ], LinkableMixin.prototype, "link", 2);
  __decorateClass([
    r3("a[data-linkable]")
  ], LinkableMixin.prototype, "_linkTags", 2);
  return LinkableMixin;
}

// src/components/jb-content-spacing/jb-content-spacing.ts
var JbContentSpacing = class extends Initiable(r) {
  constructor() {
    super(...arguments);
    this._uniqueId = Math.random().toString(36).substr(2, 9);
    this._wrappedElementName = "slotted-element";
  }
  connectedCallback() {
    super.connectedCallback();
    this.dataset.containerId = this._uniqueId;
    if (this.type) {
      this.setAttribute("data-type", this.type);
    }
  }
  async firstUpdated() {
    if (this.type === "focus") {
      this.style.setProperty("--bottom-spacing-factor", "0.5");
      if (this._followsTextComponent()) {
        this.style.setProperty("--top-spacing-factor", "0.5");
      }
    }
    if (this.type === "no-vertical-space") {
      this.style.setProperty("--vertical-spacing-factor", "0");
    }
    if (this.type === "always-half-vertical-space") {
      this.style.setProperty("--vertical-spacing-factor", "0.5");
    }
    if (this.type === "text") {
      this.style.setProperty("--vertical-spacing-factor", "0.5");
      if (this._followsTextComponent()) {
        this.style.setProperty("--top-spacing-factor", "0");
      }
    }
    if (this.type === "half-top-no-bottom") {
      this.style.setProperty("--top-spacing-factor", "0.5");
      this.style.setProperty("--bottom-spacing-factor", "0");
    }
    if (this.type === "list") {
      if (this._followsTextComponent()) {
        this.style.setProperty("--vertical-spacing-factor", "0.5");
      }
    }
    if (this.type === "media") {
      if (this._followsTextComponent()) {
        this.style.setProperty("--vertical-spacing-factor", "0.5");
      }
    }
    if (this.type === "list-without-heading") {
      this.style.setProperty("--vertical-spacing-factor", "0.5");
      if (this._followsTextComponent()) {
        this.style.setProperty("--top-spacing-factor", "0");
      }
    }
    if (this.type === "article-wide") {
      this.style.setProperty("--bottom-spacing-factor", "0");
    }
    if (this.type === "teaser-block" || this.type === "navigation-tags") {
      if (this.dataset.background) {
        if (this._followsArticleWideComponent()) {
          this.style.setProperty("margin-block-start", "72px");
        } else {
          this.style.setProperty("margin-block", "72px");
        }
      } else {
        this.style.setProperty("--vertical-spacing-factor", "0");
        this.style.setProperty("margin-block", "144px");
        if (this._followsHomePageHero() || this._followsArticleWideComponent()) {
          this.style.setProperty("margin-block-start", "72px");
        }
      }
    }
    await this.updateComplete;
    const assignedElements = this._slottedElements;
    if (assignedElements?.length > 0) {
      this._wrappedElementName = assignedElements[0].tagName.toLowerCase();
    }
  }
  async _followsArticleWideComponent() {
    const previousElement = this.previousElementSibling;
    const elmName = previousElement?.nodeName.toLowerCase();
    if (customElements.get(elmName)) {
      await customElements.whenDefined(elmName);
    }
    if (!previousElement) {
      return false;
    }
    const visiblePreviousElement = this._previousVisibleElement();
    if (!visiblePreviousElement) {
      return false;
    }
    return visiblePreviousElement.matches(['jb-content-spacing[data-type="article-wide"]'].join(", "));
  }
  _followsHomePageHero() {
    const elements = document.querySelectorAll("jb-home-page-hero, jb-content-spacing");
    let result = false;
    elements.forEach((elm, index) => {
      if (elm.nodeName === "JB-HOME-PAGE-HERO") {
        if (elements[index + 1].dataset.containerId === this._uniqueId) {
          result = true;
        }
      }
    });
    return result;
  }
  _followsTextComponent() {
    const previousElement = this.previousElementSibling;
    if (!previousElement) {
      return false;
    }
    const visiblePreviousElement = this._previousVisibleElement();
    if (!visiblePreviousElement) {
      return false;
    }
    return visiblePreviousElement.matches(
      [
        'jb-content-spacing[data-type="text"]',
        ".template-section-spacer--text-components",
        ".template-section-spacer--richtext-components"
      ].join(", ")
    );
  }
  _isHidden(element) {
    return element.style.display === "none";
  }
  _previousVisibleElement() {
    let prevElement = this.previousElementSibling;
    while (prevElement) {
      if (!this._isHidden(prevElement)) {
        return prevElement;
      }
      prevElement = prevElement.previousElementSibling;
    }
    return null;
  }
  render() {
    return ke` <section
      class=${Rt({
      ["align-" + this.align]: !!this.align,
      ["cols-" + this.colsMdUp]: !!this.colsMdUp,
      ["cols-lg-" + this.colsLgUp]: !!this.colsLgUp,
      ["has-" + this._wrappedElementName]: true,
      [to(this.horizontal)]: true,
      [to(this.type)]: true,
      "grid-legacy": this.grid === "legacy",
      grid: !!this.grid
    })}
    >
      <div><slot></slot></div>
    </section>`;
  }
};
JbContentSpacing.styles = [reset_css_default, jb_content_spacing_css_default];
__decorateClass([
  n()
], JbContentSpacing.prototype, "align", 2);
__decorateClass([
  n({ type: Number })
], JbContentSpacing.prototype, "colsLgUp", 2);
__decorateClass([
  n({ type: Number })
], JbContentSpacing.prototype, "colsMdUp", 2);
__decorateClass([
  n({ type: Boolean })
], JbContentSpacing.prototype, "grid", 2);
__decorateClass([
  n()
], JbContentSpacing.prototype, "horizontal", 2);
__decorateClass([
  n()
], JbContentSpacing.prototype, "type", 2);
__decorateClass([
  o()
], JbContentSpacing.prototype, "_slottedElements", 2);
__decorateClass([
  r2()
], JbContentSpacing.prototype, "_wrappedElementName", 2);
JbContentSpacing = __decorateClass([
  customElement("jb-content-spacing")
], JbContentSpacing);

// src/mixins/Spaceable.ts
function Spaceable(baseClass) {
  class SpaceableMixin extends baseClass {
    constructor() {
      super(...arguments);
      this._wrapped = false;
    }
    connectedCallback() {
      super.connectedCallback();
      if (this.withSpacing && !this._wrapped) {
        this._addSpacing();
      }
    }
    update(changedProperties) {
      super.update(changedProperties);
      if (changedProperties.has("withSpacing")) {
        if (this.withSpacing && !this._wrapped) {
          this._addSpacing();
        } else if (!this.withSpacing && this._wrapped) {
          this._removeSpacing();
        }
      }
    }
    _addSpacing() {
      this._wrapped = true;
      const contentSpacing = new JbContentSpacing().init({
        props: this._getContentSpacingProperties()
      });
      if (this.hasAttribute("slot")) {
        contentSpacing.setAttribute("slot", this.getAttribute("slot"));
        this.removeAttribute("slot");
      }
      if (this.hasAttribute("id")) {
        contentSpacing.setAttribute("id", this.getAttribute("id"));
        this.removeAttribute("id");
      }
      const backgroundValue = this.getAttribute("background") || this.background;
      if (backgroundValue) {
        contentSpacing.dataset.background = backgroundValue;
      }
      this._wrap(contentSpacing);
    }
    /**
     * override this method to specify the properties of the jb-content-spacing element, that will surround your component
     */
    _getContentSpacingProperties() {
      return {};
    }
    _removeSpacing() {
      this._wrapped = false;
      const contentSpacing = this.closest("jb-content-spacing");
      if (!contentSpacing) {
        return;
      }
      if (contentSpacing.hasAttribute("slot")) {
        this.setAttribute("slot", contentSpacing.getAttribute("slot"));
      }
      if (contentSpacing.hasAttribute("id")) {
        this.setAttribute("id", contentSpacing.getAttribute("id"));
      }
      if (contentSpacing.dataset.background) {
        this.setAttribute("background", contentSpacing.dataset.background);
        this.background = contentSpacing.dataset.background;
      }
      contentSpacing.replaceWith(this);
    }
    _wrap(wrapper) {
      this.parentNode?.insertBefore(wrapper, this);
      wrapper.appendChild(this);
    }
  }
  __decorateClass([
    n({ reflect: true })
  ], SpaceableMixin.prototype, "background", 2);
  __decorateClass([
    n({ type: Boolean })
  ], SpaceableMixin.prototype, "withSpacing", 2);
  return SpaceableMixin;
}

// src/components/icons/jb-download-icon/jb-download-icon.ts
var JbDownloadIcon = class extends Icon(r) {
  render() {
    return ke`
      <svg
        viewBox="0 0 18 18"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M2.30841 9.65421C2.30841 9.29288 2.01553 9 1.65421 9C1.29288 9 1 9.29288 1 9.65421V14.6166C1.00003 15.8894 2.03556 16.9249 3.30838 16.9249H14.6798C15.9526 16.9249 16.9882 15.8894 16.9882 14.6166V9.65421C16.9882 9.29288 16.6953 9 16.334 9C15.9727 9 15.6798 9.29288 15.6798 9.65421V14.6166C15.6798 15.1679 15.2312 15.6165 14.6799 15.6165H3.30835C2.75698 15.6165 2.30841 15.1679 2.30841 14.6166V9.65421Z"
        />
        <path
          d="M8.65156 11.6961C8.88436 11.9289 9.26182 11.9289 9.49464 11.6961L9.53035 11.6604L12.6922 8.49856C12.925 8.26574 12.925 7.88828 12.6922 7.65547C12.4594 7.42267 12.0819 7.42265 11.8491 7.65547L9.71976 9.7848L9.71976 1.91451C9.71975 1.55737 9.43024 1.26786 9.07311 1.26786C8.89454 1.26784 8.73286 1.34024 8.61584 1.45726C8.4988 1.57431 8.42644 1.73598 8.42644 1.91453L8.42646 9.78482L6.29712 7.65547C6.06431 7.42267 5.68686 7.42265 5.45403 7.65547C5.22121 7.8883 5.22123 8.26576 5.45403 8.49856L8.61586 11.6604L8.65156 11.6961Z"
        />
      </svg>
    `;
  }
};
JbDownloadIcon.styles = [reset_css_default, jb_download_icon_css_default];
JbDownloadIcon = __decorateClass([
  customElement("jb-download-icon")
], JbDownloadIcon);

export {
  JbDownloadIcon,
  JbExternalIcon,
  JbInPageIcon,
  JbInternalIcon,
  JbMailIcon,
  LinkableEvents,
  jbLinkClickedEventToJbTrackingEvent,
  initializeLink,
  setLink,
  getLinkIcon,
  getLinkIconName,
  Linkable,
  JbContentSpacing,
  Spaceable
};
